import React, { useState, useEffect } from 'react';
import TabItem from './TabItem';
import { TranslationFunction }  from '../../types';

interface TabsProps {
    children: any;
    onChange?: (tab: number) => void;
    unread?: number;
    translate?: TranslationFunction;
}

const Tabs: React.FC<TabsProps> = ({ translate, children, onChange, unread }) => {
    const [active, setActive] = useState(0);
    const [tabs, setTabs] = useState([]);

    useEffect(() => {
        let activeIdx = null;
        const tabList = [];

        children.forEach((child, idx: number) => {
            if (child.props.enabled) {
                tabList.push(child.props.label);
                if (child.props && child.props.active) {
                    activeIdx = idx;
                }
            }
        });

        setActive(activeIdx);
        setTabs(tabList);
    }, []);

    const handleTabSelect = (index: number) => {
        setActive(index);
        if (onChange) {
            onChange(index);
        }
    };

    return (
        <>
            {tabs.length > 1 &&
                <div className="tabs">
                    {tabs.map((child, idx) => (
                        <TabItem
                            active={active === idx}
                            key={child}
                            idx={idx}
                            label={child}
                            translate={translate}
                            onClick={handleTabSelect}
                            unread={unread}
                        />
                    ))}
                </div>
            }

            {children.map((child, idx) => {
                if (!child.props.enabled || idx !== active) return null;

                return (
                    <div key={idx} className="tab__content">
                        {child.props.children}
                    </div>
                );
            })}
        </>
    );
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/Tabs/Tabs.tsx